import {createRouter, createWebHashHistory} from 'vue-router';
import Dashboard from '../views/DashboardView.vue';
import Page from '../views/PageView.vue';
import AddNewPageView from '../views/AddNewPageView.vue';
import Component from '../views/ComponentView.vue';
import Login from '../views/LoginView.vue';
import Signup from '../views/SignupView.vue';
import ImageView from '../views/ImageView.vue';
import SettingsView from '../views/SettingsView.vue';
import EditPageView from '../views/EditPageView.vue';
import ProductListView from '../views/ProductListView.vue';
import ProductCreationView from '../views/ProductCreationView.vue';
import CategoryList from '../views/CategoryList.vue';
import EditProductView from '../views/EditProductView.vue';
import axios from 'axios';

const routes = [
    {path: '/dashboard', component: Dashboard, meta: {requiresAuth: true}},  // Protect this route
    {path: '/page', component: Page, meta: {requiresAuth: true}},  // Protect this route
    {path: '/add-page', component: AddNewPageView, meta: {requiresAuth: true}},  // Protect this route
    {path: '/edit-page/:id', component: EditPageView, props: true, meta: {requiresAuth: true}},  // Protect this route
    {path: '/image', component: ImageView, meta: {requiresAuth: true}},  // Protect this route
    {path: '/product', component: ProductListView, meta: {requiresAuth: true}},  // Protect this route
    {
        path: '/product-update/:productId',
        component: EditProductView,
        name: 'ProductUpdate',
        props: true,
        meta: {requiresAuth: true}
    },  // Protect this route
    {path: '/category', component: CategoryList, meta: {requiresAuth: true}},  // Protect this route
    {path: '/add-product', component: ProductCreationView, name: 'ProductCreate', meta: {requiresAuth: true}},  // Protect this route
    {path: '/settings', component: SettingsView, meta: {requiresAuth: true}},  // Protect this route
    {path: '/download', component: Component, meta: {requiresAuth: true}},  // Protect this route
    {path: '/contact', component: Component, meta: {requiresAuth: true}},  // Protect this route
    {path: '/newsletter', component: Component, meta: {requiresAuth: true}},  // Protect this route
    {path: '/login', component: Login},
    {path: '/signup', component: Signup},
    {path: '/', redirect: '/dashboard'},
];

const router = createRouter({
    history: createWebHashHistory(),  // Use hash mode for Vue Router
    routes,
});

// Add a navigation guard to check authentication
router.beforeEach(async (to, from, next) => {
    // Check if the route requires authentication
    if (to.meta.requiresAuth) {
        try {
            // Call the API to check if the user is authenticated
            const response = await axios.get('/dashboard/check-login-status/');
            const isAuthenticated = response.data.isAuthenticated;

            if (isAuthenticated) {
                next();  // Allow access to the route
            } else {
                next('/login');  // Redirect to login if not authenticated
            }
        } catch (error) {
            console.error('Error checking authentication:', error);
            next('/login');  // Redirect to login on error
        }
    } else {
        // For non-authenticated routes like login or signup
        next();  // Proceed as usual
    }
});

export default router;
